// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	/*
	var elem = document.querySelector('#slideshow');
	var flkty = new Flickity( elem, {
		// options
		cellSelector: '.slide-cell',
		wrapAround: true,
		prevNextButtons: false,
		autoPlay: 7000
	});
	*/

	// Toggle nav background panel
	const myCollapsible = document.getElementById('navbarPrimary')
	myCollapsible.addEventListener('show.bs.collapse', event => {
		document.body.classList.add('navopen');
	})
	myCollapsible.addEventListener('hide.bs.collapse', event => {
		document.body.classList.remove('navopen');
	})

	// Fix navbar when scrolling up
	document.addEventListener("DOMContentLoaded", function(){
		window.addEventListener('scroll', function() {
			if (window.scrollY > 140) {
				document.querySelector('.header-main').classList.add('fixed-top');
				let navbar = document.querySelector('.header-main');
				let navbar_height = navbar.offsetHeight;
				document.body.style.paddingTop = navbar_height + 'px';
			} else {
			 	document.querySelector('.header-main').classList.remove('fixed-top');
				document.body.style.paddingTop = '0';
			}
		});
	});
    
    var lastScrollTop = 0;

      window.addEventListener("scroll", function(){ // 
         var st = window.pageYOffset || document.documentElement.scrollTop;
         var header = document.querySelector('.header-main');
         var sidebar = document.querySelector('.sidebar-primary');

         if (st > lastScrollTop){
            header.classList.remove("reverse");
            if (sidebar !== null) {
                sidebar.classList.remove("reverse"); 
            }

         } else {
            header.classList.add("reverse");
            if (sidebar !== null) {
                sidebar.classList.add("reverse");
            }
         }

         if(window.pageYOffset <= 140){
            header.classList.remove("reverse");
            if (sidebar !== null) {
                sidebar.classList.remove("reverse");
            }
         }
         
         //console.log("lastScrollTop:"+lastScrollTop);
         //console.log("st:"+st);

         lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }, false);

	// Subnav
	const subnav = document.querySelector('.subnav-collapse');
	//console.log(subnav);
	const subnavHeading = document.querySelector('.sidenav-heading');
	if (subnav && subnavHeading) {
		subnav.innerHTML = subnavHeading.innerText;
	}

	// Instantiate Dashboard Gridder
	const gridderDashboard = document.getElementById('ppDashboard');
	if (gridderDashboard) {
		new GridderJS('.gridder', {
			columns: 4,
			gap: 16,
			breakpoints: {
				991: {
						columns: 2,
						gap: 16,
				},
				575: {
						columns: 1,
						gap: 16,
				}
			}
		});
	}

	// Dynamic content video modals
	const videoModal = document.getElementById('videoModal');
	if (videoModal) {
		videoModal.addEventListener('show.bs.modal', event => {
			const button = event.relatedTarget
			const videoID = button.getAttribute('data-bs-videoid')
			const videoTitle = button.getAttribute('data-bs-videotitle')
			const modalTitle = videoModal.querySelector('.modal-title')
			const modalVideoEmbed = videoModal.querySelector('.video-player')
		
			modalTitle.textContent = videoTitle
			modalVideoEmbed.src = videoID
		})
		videoModal.addEventListener('hide.bs.modal', event => {
			const modalVideoEmbed = videoModal.querySelector('.video-player')
	
			modalVideoEmbed.src = ''
		});
	}

	// Branch news select
	const branchNews = document.getElementById('branch-state');
	if (branchNews) {
		console.log(branchNews.options[branchNews.selectedIndex].value);
		branchNews.addEventListener('change', function handleChange(event) {
			console.log(branchNews.options[branchNews.selectedIndex].value);
			if (branchNews.options[branchNews.selectedIndex].value === '') {
				window.location.pathname = '/news/';
			}
			else if (branchNews.options[branchNews.selectedIndex].value === 'all') {
				window.location.pathname = '/news/category/branch-news/';
			}
			else {
				window.location.pathname = '/news/branches/'+branchNews.options[branchNews.selectedIndex].value;
			}
		});
	}

	// Branch events select
	const branchEvents = document.getElementById('branch-events-select');
	if (branchEvents) {
		console.log(branchEvents.options[branchEvents.selectedIndex].value);
		branchEvents.addEventListener('change', function handleChange(event) {
			console.log(branchEvents.options[branchEvents.selectedIndex].value);
			if (branchEvents.options[branchEvents.selectedIndex].value === '') {
				window.location.pathname = '/events/';
			}
			else if (branchEvents.options[branchEvents.selectedIndex].value === 'all') {
				window.location.pathname = '/events/categories/branch-events/';
			}
			else {
				window.location.pathname = '/events/categories/'+branchEvents.options[branchEvents.selectedIndex].value;
			}
		});
	}
    
    //GSAP ANIMATION
    const who = document.querySelector('.layout--who');
    if (who !== null) {
        
        let mm = gsap.matchMedia();

        mm.add("(min-width: 576px)", () => {
                ScrollTrigger.defaults({
                  markers:false
                })

                var points = gsap.utils.toArray('.section--slides-wrap');

                var height = 200 * points.length;

                var tl = gsap.timeline({
                  duration: points.length,
                  scrollTrigger: {
                    trigger: ".section--slides",
                    start: "top center",
                    end: "+="+height+"%",
                    scrub: true,
                    id: "points",
                  }
                })
                
                var pinner = gsap.timeline({
                  scrollTrigger: {
                    trigger: ".section--slides",
                    start: "top top",
                    end: "+="+height+"%",
                    scrub: true,
                    pin: ".section--slides",
                    pinSpacing: true,
                    id: "pinning",
                    markers: false
                  }
                })
				
				var i = 0;
                points.forEach(function(elem, i) {
                  gsap.set(elem, {position: "absolute", top: 0});

				  if(i != 0){
					tl.from(elem.querySelector('.section--slides-img'), {autoAlpha:0}, i)
				  }
                  tl.from(elem.querySelector('.section--slides-copy'), {autoAlpha:0, translateY: 200}, i)
                  
                  if (i != points.length-1) {
                    tl.to(elem.querySelector('.section--slides-copy'), {autoAlpha:0, translateY: -200}, i + 0.75)
                    tl.to(elem.querySelector('.section--slides-img'), {autoAlpha:0}, i + 0.75)
                  }
				  i++;
                  
                });
            });
        }
    
	jQuery(function($) {
	  $('body').on('click', '.edit-member-order', function() {
		  var data = {
			  'action': 'gf_get_order_form',
			  'orderid': $(this).data('orderid'),
			  'security': edit_member_order.security
		  };

		  $.post(edit_member_order.ajaxurl, data, function(response) {
			  response = JSON.parse(response);
			  $('#myModal .modal-content').html(response);
			  var myModal = new bootstrap.Modal(document.getElementById('myModal'));
			  myModal.show();
			  jQuery('#gform_13').attr('action', '');
		  });
	  });
	});

} )();